import React from 'react';
import { ModalButton, Header, Content } from 'components/modal';
import { btnThemes } from 'components/button';
import { iconTypes } from 'components/icon';

import StatusTopic from './status-topic';
import MergeModalContent from './merge-theme-content';
import MoveThemeContent from './move-theme-content';
import RemoveThemeContent from './remove-theme-content';
import OnModeration from './on-moderation';
import BanPosts from './ban-posts';

export default function (bemClasses) {
  const { onResetSelection, selectedItems } = this.props;
  if (!selectedItems) return null;

  return (
    <>
      <ModalButton
        {...bemClasses('item')}
        buttonProps={{
          iconType: iconTypes.star,
          title: 'Важная/неважная тема',
          iconOnly: true,
          theme: btnThemes.white
        }}
        classNameModal={bemClasses('modal', 'important').className}
        size="small"
      >
        <Header closeButton children="Статус темы" />
        <Content>
          <div>
            <StatusTopic
              statusType="important"
              topicItems={selectedItems}
              onResetSelection={onResetSelection}
            />
          </div>
        </Content>
      </ModalButton>
      <ModalButton
        {...bemClasses('item')}
        buttonProps={{
          iconType: iconTypes.affix,
          title: 'Прилепить/отлепить',
          iconOnly: true,
          theme: btnThemes.white
        }}
        classNameModal={bemClasses('modal', 'stick').className}
        size="small"
      >
        <Header closeButton children="Прилепить/отлепить тему" />
        <Content>
          <div>
            <StatusTopic
              statusType="stick"
              topicItems={selectedItems}
              onResetSelection={onResetSelection}
            />
          </div>
        </Content>
      </ModalButton>
      <ModalButton
        {...bemClasses('item')}
        buttonProps={{
          iconType: iconTypes.lock,
          title: 'Закрыть/открыть',
          iconOnly: true,
          theme: btnThemes.white
        }}
        classNameModal={bemClasses('modal', 'locked').className}
        size="small"
      >
        <Header closeButton children="Закрыть/открыть тему" />
        <Content>
          <div>
            <StatusTopic
              statusType="locked"
              topicItems={selectedItems}
              onResetSelection={onResetSelection}
            />
          </div>
        </Content>
      </ModalButton>
      {selectedItems.length > 0 &&
        <ModalButton
          {...bemClasses('item')}
          buttonProps={{
            iconType: iconTypes.newTab,
            title: 'Переместить',
            iconOnly: true,
            theme: btnThemes.white
          }}
          classNameModal={bemClasses('modal', 'move').className}
          size="big"
        >
          <Header closeButton children="Переместить тему в другой форум" />
          <Content>
            <MoveThemeContent
              listBoxItems={selectedItems}
              onResetSelection={onResetSelection}
            />
          </Content>
        </ModalButton>
      }
      {selectedItems.length > 1 &&
        <ModalButton
          {...bemClasses('item')}
          buttonProps={{
            iconType: iconTypes.copyLink,
            title: 'Объединить темы',
            iconOnly: true,
            theme: btnThemes.white
          }}
          classNameModal={bemClasses('modal', 'merge').className}
          size="big"
        >
          <Header closeButton children="Объединить темы" />
          <Content>
            <div>
              <MergeModalContent
                listBoxItems={selectedItems}
                onResetSelection={onResetSelection}
              />
            </div>
          </Content>
        </ModalButton>
      }
      <ModalButton
        {...bemClasses('item')}
        buttonProps={{
          iconType: iconTypes.flag,
          title: 'Добавить/Убрать с премодерации',
          iconOnly: true,
          theme: btnThemes.white
        }}
        classNameModal={bemClasses('modal', 'moderation').className}
        size="small"
      >
        <Header closeButton children="Добавить/Убрать с премодерации" />
        <Content>
          <div>
            <OnModeration
              topicItems={selectedItems}
              onResetSelection={onResetSelection}
            />
          </div>
        </Content>
      </ModalButton>
      <ModalButton
        {...bemClasses('item')}
        buttonProps={{
          iconType: iconTypes.announcement,
          title: 'Запретить/Разрешить постить Новым пользователям',
          iconOnly: true,
          theme: btnThemes.white
        }}
        classNameModal={bemClasses('modal', 'ban').className}
        size="small"
      >
        <Header closeButton children="Запретить/Разрешить постить Новым пользователям" />
        <Content>
          <div>
            <BanPosts
              topicItems={selectedItems}
              onResetSelection={onResetSelection}
            />
          </div>
        </Content>
      </ModalButton>
      {selectedItems.length > 0 &&
        <ModalButton
          {...bemClasses('item')}
          buttonProps={{
            iconType: iconTypes.delete,
            title: 'Удалить',
            iconOnly: true,
            theme: btnThemes.white
          }}
          classNameModal={bemClasses('modal', 'remove').className}
          size="big"
        >
          <Header closeButton children="Удалить темы" />
          <Content>
            <div>
              <RemoveThemeContent
                listBoxItems={selectedItems}
                onResetSelection={onResetSelection}
              />
            </div>
          </Content>
        </ModalButton>
      }
    </>
  );
}
